import { RouteLocationRaw } from 'vue-router';

export type UiTabsOption = {
  title: string;
  to: RouteLocationRaw;
};

export enum UiPaginationMode {
  /** @deprecated - использовать {@link UiPaginationMode.LINKS}  */
  BUTTONS = 'buttons',
  LINKS = 'links',
}

export enum UiPaginationType {
  DEFAULT = 'default',
  COMPACT = 'compact',
}

export enum UiTagTheme {
  BLANK = 'blank',
  GREY = 'grey',
  INFO = 'info',
  DEFAULT = 'default',
  DANGER = 'danger',
  SUCCESS = 'success',
}

export enum UiTagWeight {
  NORMAL = 'normal',
  BOLDER = 'bolder',
}
